import {useEffect, useMemo, useState} from 'react';

export const useLeadsPool = (
  initialReceiveLeads: boolean = true,
  visible = false,
) => {
  const [receiveLeads, setReceiveLeads] =
    useState<boolean>(initialReceiveLeads);

  useEffect(() => {
    if (visible) {
      setReceiveLeads(initialReceiveLeads);
    }
  }, [visible, initialReceiveLeads]);

  const isDirty = useMemo(() => {
    return receiveLeads !== initialReceiveLeads;
  }, [receiveLeads, initialReceiveLeads]);

  const canSave = true;

  const resetState = (): void => {
    setReceiveLeads(initialReceiveLeads);
  };

  return {
    receiveLeads,
    setReceiveLeads,
    isDirty,
    canSave,
    resetState,
  };
};
